"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".resultContent_77ff388a{display:table-row}.resultContent_77ff388a .resultItem_77ff388a{display:table-cell;vertical-align:bottom}.peoplePickerPersona_77ff388a{width:180px}.peoplePickerPersona_77ff388a .ms-Persona-details{width:100%}.peoplePicker_77ff388a .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_77ff388a{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:7px 12px}\n" }]);
exports.resultContent = "resultContent_77ff388a";
exports.resultItem = "resultItem_77ff388a";
exports.peoplePickerPersona = "peoplePickerPersona_77ff388a";
exports.peoplePicker = "peoplePicker_77ff388a";
exports.peoplePickerPersonaContent = "peoplePickerPersonaContent_77ff388a";
//# sourceMappingURL=PeoplePicker.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/FloatingPicker/PeoplePicker/PeoplePicker.scss.js
// module id = 788
// module chunks = 0